module.exports = {"211122101":"沙岭镇","211122102":"高升镇","211122103":"胡家镇","211122104":"石新镇","211122105":"东郭镇","211122106":"羊圈子镇","211122107":"古城子镇","211122108":"坝墙子镇","211122109":"太平镇","211122110":"陈家镇","211122111":"甜水镇","211122112":"吴家镇","211122113":"得胜镇","211122400":"盘山县林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211122.json
// module id = 534
// module chunks = 0